import { Reveal } from "./Reveal";

// Intestazione pagina interna, stile editoriale.
export const PageHeader = ({ eyebrow, title, subtitle }) => {
  return (
    <section className="pt-36 md:pt-44 pb-8 md:pb-12 border-b border-border/60">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.28em] text-sage-dark mb-6">{eyebrow}</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-ink tracking-tight leading-[0.95] max-w-4xl text-balance">
            {title}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={0.16}>
            <p className="mt-8 text-lg text-stone leading-relaxed max-w-2xl">{subtitle}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
};
